import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Order print products',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Product details',
    [ProductOrderingSteps.ShippingInfo]: 'Shipping info',
    payment: 'Payment',
  },
  form: {
    title: 'Order details',
    polygraphy_product_id: {
      label: 'Product',
      placeholder: 'Select product',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Flyer - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Template #1 🆕',
            [FlyerTemplate.Two]: 'Template #2 🆕',
            [FlyerTemplate.Three]: 'Template #3',
            [FlyerTemplate.Four]: 'Template #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Sticker - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Template #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Door Sticker - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Template #1 🆕',
            [DoorStickerTemplate.Two]: 'Template #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Quantity',
      placeholder: 'Enter quantity',
    },
    service_level: {
      label: 'Service level',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Saver',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Company',
      placeholder: 'Enter company name',
    },
    shipping_salutation: {
      label: 'Salutation',
      options: {
        mr: 'Mr',
        mrs: 'Mrs',
      },
    },
    shipping_first_name: {
      label: 'First name',
      placeholder: 'Enter first name',
    },
    shipping_last_name: {
      label: 'Last name',
      placeholder: 'Enter last name',
    },
    shipping_country: {
      label: 'Country',
      placeholder: 'Select country',
    },
    shipping_state: {
      label: 'State',
      placeholder: 'Select state',
    },
    shipping_city: {
      label: 'City',
      placeholder: 'Enter city',
    },
    shipping_address: {
      label: 'Address',
      placeholder: 'Enter address',
    },
    shipping_zip_code: {
      label: 'Zip',
      placeholder: 'Enter zip code',
    },
    shipping_phone_number: {
      label: 'Phone number',
      placeholder: 'Enter phone number',
    },
    create_invoice: {
      options: {
        true: 'Bill automatically - Get charged instantly',
        false: 'Send for free - This is a gift',
      },
    },
  },
  table: {
    title: 'Previous orders',
    fields: {
      product: 'Product',
      quantity: 'Quantity',
      status: 'Status',
      service_level: 'Service level',
      shipping: 'Shipping',
      tracking_url: 'Tracking url',
      created: 'Created',
      updated: 'Last update',
    },
  },
  labels: {
    shipping_company: 'Company',
    shipping_salutation: 'Salutation',
    shipping_first_name: 'First name',
    shipping_last_name: 'Last name',
    shipping_address: 'Address',
    shipping_zip_code: 'Zip code',
    shipping_city: 'City',
    shipping_phone_number: 'Phone number',
    show_shipping_details: 'Shipping details',
    track_order: 'Track order',
    pending_from_provider: 'Pending from provider',
  },
  modals: {
    confirmation: {
      title: 'Confirm order details',
    },
    free_order_confirmation: {
      title: 'Are you sure you want to send {{product}} for free?',
      description: 'You’ve chosen not to charge your customer today.\n Product will be dispatched without payment.',
      buttons: {
        confirm: 'Yes, send for free',
      },
    },
  },
  buttons: {
    back_to_templates: 'Back to templates',
    preview: 'Preview',
    next: 'Next',
    order: 'Create order',
    confirm: 'Confirm',
  },
  feedback: {
    shop_url_used: 'Product includes Online shop URL (<url>{{url}}</url>). Is this on purpose?',
    order_total_price: 'Total price for the selected products: <strong>{{amount}} NET</strong>',
  },
  toasts: {
    failed_to_create_order: 'Failed to create an order',
    order_got_created: 'Order got created',
    failed_to_load_data: 'Failed to load data',
  },
};
